import { render, staticRenderFns } from "./policies.vue?vue&type=template&id=79753b77&scoped=true"
import script from "./policies.vue?vue&type=script&lang=js"
export * from "./policies.vue?vue&type=script&lang=js"
import style0 from "./policies.vue?vue&type=style&index=0&id=79753b77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79753b77",
  null
  
)

export default component.exports